__turbopack_context__.v({
  "component": "style-module-scss-module__Sz2Wba__component",
  "error": "style-module-scss-module__Sz2Wba__error",
  "large": "style-module-scss-module__Sz2Wba__large",
  "success": "style-module-scss-module__Sz2Wba__success",
  "warning": "style-module-scss-module__Sz2Wba__warning",
});
